import React, { useEffect } from "react"
import { navigate } from "gatsby"

import albedo from "@albedo-link/intent"

import { StaticImage } from "gatsby-plugin-image"

import Layout from "../components/layout"
import Seo from "../components/seo"

import { usePublicKey } from "../hooks/usePublicKey"

const IndexPage = () => {
  const { publicKey, setPublicKey } = usePublicKey()

  useEffect(() => {
    if (publicKey) {
      navigate("/inventory")
    }
  }, [publicKey])

  const login = () => {
    albedo.publicKey().then(response => setPublicKey(response.pubkey))
  }

  return (
    <Layout>
      <Seo title="MIGAS GAME" />
      <div>
        <StaticImage src="../images/migas.png" width={256} alt="MIGAS GAME" />
      </div>
      <p>You need <a href="https://albedo.link/" rel="nofollow" target="_blank">Albedo browser extension</a> to play.</p>
      <p>This game is in Alpha stage and is running over Stellar Testnet only</p>
      <button style={{ marginTop: 12 }} onClick={login}>
        Login
      </button>
    </Layout>
  )
}

export default IndexPage
